import { DOCUMENT_SIDES } from 'features/govtId/v2/helper/constants';

/* -------- document -------- */
export const selectDocumentTransactionId = (s) => s?.govtIdV2?.document?.transactionId ?? null;

export const selectDocumentImages = (s) => s?.govtIdV2?.document?.images ?? [];

export const selectDocumentFrontImage = (s) => {
    const images = selectDocumentImages(s);

    return images.find(({ side }) => side === DOCUMENT_SIDES.FRONT) ?? images[0] ?? null;
};

export const selectDocumentStatus = (s) => s?.govtIdV2?.document?.status;

export const selectDocumentErrorCode = (s) => s?.govtIdV2?.document?.errorCode ?? null;

/* -------- selfie -------- */
export const selectSelfieSessionId = (s) => s?.govtIdV2?.selfie?.sessionId ?? null;

export const selectSelfieStatus = (s) => s?.govtIdV2?.selfie?.status;

export const selectSelfieFailureReason = (s) => s?.govtIdV2?.selfie?.failureReason ?? null;

/* -------- ui -------- */
export const selectCaptureFlowMode = (s) => s?.govtIdV2?.ui?.captureFlowMode;

export const selectModeGuidance = (s) => s?.govtIdV2?.ui?.modeGuidance;

export const selectShowInstructions = (s) => s?.govtIdV2?.ui?.showInstructions ?? false;

export const selectInstructionType = (s) => s?.govtIdV2?.ui?.instructionType ?? null;

export const selectCameraPermissionGuide = (s) => s?.govtIdV2?.ui?.cameraPermissionGuide ?? {};
